import { faArrowUpFromBracket } from '@fortawesome/pro-regular-svg-icons/faArrowUpFromBracket';
import { Icon } from '@kontentino/ui';
import { ActionContext, createAction } from 'actions';
import i18n from 'app/utils/i18n';
import { modalRoutes } from 'constants/routes';
import { UserPermission } from 'constants/userPermission';
import { PostDetail } from 'types/PostDetail';

export const sharePostExternally = (context: ActionContext) =>
  createAction(
    {
      id: 'share-post-externally',
      label: () => i18n.t('shareExternally'),
      icon: <Icon icon={faArrowUpFromBracket} />,
      scopes: UserPermission.POST_SHARE_PREVIEW,
      perform: ({ id }: { id: PostDetail['id'] }) => {
        context.modalHistory.push({
          hash: modalRoutes.SHARE_PREVIEW,
          search: `?id=${id}`,
        });
      },
    },
    context,
  );
